"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _httpStatusCodes = _interopRequireDefault(require("http-status-codes"));
var _coreV = require("@stt-componentes/core-v2");
var _core2 = require("@stt-componentes/core");
var _axios = _interopRequireDefault(require("axios"));
var _constantes = _interopRequireDefault(require("./constantes"));
var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _cryptoBrowserify = _interopRequireDefault(require("crypto-browserify"));
var _cache = require("@stt-componentes/cache");
var _reactNotifications = require("react-notifications");
require("./estilos.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    radioLabel: {
      display: "flex",
      flexDirection: "row",
      alignItems: "baseline"
    },
    carregando: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      width: "100%"
    }
  };
});
var Popup = function Popup(props) {
  var apiSttOauth = props.apiSttOauth,
    cpfResponsavel = props.cpfResponsavel,
    documentos = props.documentos,
    callback = props.callback,
    onCancel = props.onCancel;
  var _useContext = (0, _react.useContext)(_core2.SttTranslateHook.I18nContext),
    strings = _useContext.strings;
  var classes = useStyles();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    init = _useState2[0],
    setInit = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    escopoCandidato = _useState4[0],
    setEscopoCandidato = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    escopo = _useState6[0],
    setEscopo = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    pscConfig = _useState8[0],
    setPscConfig = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    selecionarEscopo = _useState10[0],
    setSelecionarEscopo = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    descobrirUsuario = _useState12[0],
    setDescobrirUsuario = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    autorizando = _useState14[0],
    setAutorizando = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    gerandoToken = _useState16[0],
    setGerandoToken = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    assinando = _useState18[0],
    setAssinando = _useState18[1];
  var _useState19 = (0, _react.useState)(null),
    _useState20 = _slicedToArray(_useState19, 2),
    authorizationCode = _useState20[0],
    setAuthorizationCode = _useState20[1];
  var _useState21 = (0, _react.useState)(null),
    _useState22 = _slicedToArray(_useState21, 2),
    codeVerifier = _useState22[0],
    setCodeVerifier = _useState22[1];
  var _useState23 = (0, _react.useState)(false),
    _useState24 = _slicedToArray(_useState23, 2),
    popupFechado = _useState24[0],
    setPopupFechado = _useState24[1];
  var _useState25 = (0, _react.useState)(false),
    _useState26 = _slicedToArray(_useState25, 2),
    naoMostrarNovamente = _useState26[0],
    setNaoMostrarNovamente = _useState26[1];

  // Callers antigos só conhecem callback; os novos precisam liberar a sessão no backend.
  var cancelar = function cancelar() {
    if (onCancel) {
      onCancel();
      return;
    }
    callback();
  };

  /**
   * Entry point
   *
   * Inicia o processo tentando assinar o documento imediatamente.
   *  - Se não houver token de sessão armazenado, ou se a sessão expirar, inicia o fluxo de autorização
   *
   * Passos do fluxo de assinatura digital:
   *
   * 1. Escolha do escopo:
   *  1.1. Usuário escolhe assinar apenas um documento - escopo "single_signature"
   *  1.2. Usuário escolhe assinar vários documentos - escopo "multi_signature"
   *  1.3. Usuário escolhe iniciar uma sessão de assinatura - escopo "signature_session"
   *
   * 2. Faz a descoberta do usuário (user discovery) através do CPF
   *  2.1. Se apenas um PSC for retornado, inicia o fluxo de autorização
   *  2.2. Se mais de um PSC for retornado, apresenta a lista para o usuário escolher
   *
   * 3. Inicia o processo de autorização (redireciona para a URL de autorização do PSC)
   * 4. Obtém o código de autorização e troca pelo token
   * 5. Assina o(s) documento(s)
   */
  (0, _react.useEffect)(function () {
    setAssinando(true);
    return function () {
      setAutorizando(false);
      setGerandoToken(false);
      setAssinando(false);
    };
  }, []);

  /**
   * Gera e armazena um cookie para não mostrar mais o modal de escolha do escopo, fazendo com que a etapa de assinatura seja ignorada.     *
   */
  (0, _react.useEffect)(function () {
    if (naoMostrarNovamente) {
      document.cookie = "".concat(_constantes["default"].NAO_ASSINAR, "=true; max-age=14400; path=/; SameSite=Strict;");
      cancelar();
    }
  }, [naoMostrarNovamente]);

  /**
   * Reinicia o processo de assinatura digital
   *  - O processo é reiniciado quando a sessão expira e o servidor retorna 401 Unauthorized
   *  - Limpa todos os estados e volta para a etapa de escolha do escopo
   */
  (0, _react.useEffect)(function () {
    if (init) {
      setEscopoCandidato(null);
      setPscConfig(null);
      setAutorizando(false);
      setGerandoToken(false);
      setAssinando(false);
      setEscopo(null);
      setDescobrirUsuario(false);
      setSelecionarEscopo(true);
    }
  }, [init]);

  /**
   * Quando o escopo é definido, inicia o processo de descoberta do usuário
   */
  (0, _react.useEffect)(function () {
    if (!escopo) {
      return;
    }
    setDescobrirUsuario(true);
    setSelecionarEscopo(false);
  }, [escopo]);

  /**
   * Executa o processo de descoberta do provedor de assinatura digital (PSC - Provedor de Serviço de Confiança) através do CPF do usuário
   *  - Se apenas um PSC é retornado, inicia o processo de autorização
   *  - Se mais de um PSC é retornado, apresenta a lista para o usuário escolher
   */
  (0, _react.useEffect)(function () {
    if (descobrirUsuario) {
      var options = {
        params: {
          cpf: "000000".concat(cpfResponsavel).slice(-11)
        },
        timeout: 15000,
        headers: {
          Authorization: "Bearer ".concat(_cache.Cache.getAccessToken())
        }
      };
      _axios["default"].get("".concat(apiSttOauth, "/assinatura-digital/user-discovery"), options).then(function (response) {
        var _response$data;
        if (((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.length) === 1) {
          setPscConfig(response.data[0]);
          return;
        }
        setPscConfig(response.data);
      })["catch"](function (err) {
        console.error("Erro ao procurar certificados do usuário", err);
        setDescobrirUsuario(false);
        setSelecionarEscopo(true);
        _reactNotifications.NotificationManager.error(strings.erroGenerico);
      });
    }
  }, [descobrirUsuario]);

  /**
   * Handler para mudança na seleção do escopo
   *
   * @param {object} e
   */
  var handleChangeEscopo = function handleChangeEscopo(e) {
    setEscopoCandidato(e.target.value);
  };

  /**
   * Confirma a opção de assinatura selecionada
   *
   * @param {string} escopo
   */
  var confirmarEscopo = function confirmarEscopo(escopo) {
    setEscopo(escopo);
    setSelecionarEscopo(false);
  };

  /**
   * Inicia o processo de autorização quando o PSC é selecionado
   */
  (0, _react.useEffect)(function () {
    if (Object.prototype.toString.call(pscConfig) === '[object Object]') {
      setAutorizando(true);
      setDescobrirUsuario(false);
    }
  }, [pscConfig]);

  /**
   * Inicia o processo de autorização do usuário através da API
   * - Cria o Code Verifier, o Code Challenge e o state
   * - Redireciona o usuário para a URL de autorização do PSC
   */
  (0, _react.useEffect)(function () {
    if (!autorizando) {
      return;
    }
    // 1. Cria o Code Verifier, o Code Challenge e o state
    // https://datatracker.ietf.org/doc/html/rfc7636
    var codeVerifier = createCodeVerifier();
    localStorage.setItem(_constantes["default"].CODE_VERIFIER, codeVerifier);
    var codeChallenge = createCodeChallenge(codeVerifier);
    var state = base64Encode(generateRamdomString(10));
    localStorage.setItem(_constantes["default"].STATE, state);

    // 2. Inicia o processo de authorização do usuário através da API
    var parametros = new URLSearchParams({
      response_type: "code",
      client_id: pscConfig.client_id,
      code_challenge: codeChallenge,
      code_challenge_method: "S256",
      scope: escopo,
      state: state,
      redirect_uri: pscConfig.redirect_uri,
      login_hint: "000000".concat(cpfResponsavel).slice(-11)
    });
    var url = "".concat(pscConfig.authorize_url, "?").concat(parametros.toString());
    popup(url);

    // 3. Aguarda o código de autorização ser armazenado no localStorage
    window.addEventListener("storage", function (event) {
      var key = event.key,
        newValue = event.newValue;
      if (key === _constantes["default"].AUTHORIZATION_CODE) {
        setAuthorizationCode(newValue);
        setCodeVerifier(localStorage.getItem(_constantes["default"].CODE_VERIFIER));
      }
    });
  }, [autorizando]);

  /**
   * Gera uma string aleatória com o tamanho especificado
   *
   * @param {number} size
   * @returns
   */
  var generateRamdomString = function generateRamdomString(size) {
    return _cryptoBrowserify["default"].randomBytes(size);
  };

  /**
   * Cria o code verifier
   *
   * @returns string
   */
  var createCodeVerifier = function createCodeVerifier() {
    var str = generateRamdomString(32);
    return base64Encode(str);
  };

  /**
   * Cria o code challenge
   *
   * @param {string} codeVerifier
   * @returns
   */
  var createCodeChallenge = function createCodeChallenge(codeVerifier) {
    var hash = _cryptoBrowserify["default"].createHash("sha256").update(codeVerifier).digest();
    return base64Encode(hash);
  };

  /**
   * Codifica uma string em base64 URL-safe
   *
   * @param {string} str
   * @returns
   */
  var base64Encode = function base64Encode(str) {
    return str.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
  };

  /**
   * Abre um popup centralizad0 na tela
   *
   * @param {string} url
   */
  var popup = function popup(url) {
    var h = 650;
    var w = 550;
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;
    var systemZoom = width / window.screen.availWidth;
    var left = (width - w) / 2 / systemZoom + dualScreenLeft;
    var top = (height - h) / 2 / systemZoom + dualScreenTop;
    var popupFeatures = "\n            popup=true\n            width=".concat(w / systemZoom, ", \n            height=").concat(h / systemZoom, ", \n            top=").concat(top, ", \n            left=").concat(left);
    var popupWindow = window.open(url, "_blank", popupFeatures);
    var checkPopupClosed = setInterval(function () {
      if (popupWindow.closed) {
        clearInterval(checkPopupClosed);
        setPopupFechado(true);
      }
    }, 1000);
  };

  /**
   * Notifica o usuário se o popup foi fechado sem que o processo de autorização tenha sido concluído
   *  - O processo de autorização é concluído quando o código de autorização é obtido
   *  - Se o popup for fechado antes disso, o processo é cancelado
   */
  (0, _react.useEffect)(function () {
    if (popupFechado && !authorizationCode) {
      _reactNotifications.NotificationManager.info("Processo de assinatura cancelado.");
      cancelar();
    }
  }, [authorizationCode, popupFechado]);

  /**
   * Inicia o processo de geração do token de acesso
   *  - O processo é iniciado quando o código de autorização e o code verifier estão disponíveis
   *  - O processo de geração do token de acesso é iniciado automaticamente após a autorização
   */
  (0, _react.useEffect)(function () {
    if (authorizationCode && codeVerifier) {
      setGerandoToken(true);
      setAutorizando(false);
    }
  }, [authorizationCode, codeVerifier]);

  /**
   * Gera o token de acesso através da API
   */
  (0, _react.useEffect)(function () {
    if (!gerandoToken) {
      return;
    }
    var headers = {
      "Content-type": "application/json",
      Authorization: "Bearer ".concat(_cache.Cache.getAccessToken())
    };
    _axios["default"].post("".concat(apiSttOauth, "/assinatura-digital/token"), {}, {
      params: {
        psc: pscConfig.psc,
        code: authorizationCode,
        code_verifier: codeVerifier
      },
      headers: headers
    }).then(function (response) {
      setAssinando(true);
      setGerandoToken(false);
    })["catch"](function (err) {
      console.log(err);
      var response = err.response;
      var msg = "Ocorreu um erro desconhecido. Entre em contato com os administradores do sistema.";
      if (response) {
        msg = response.data.msg;
      }
      setGerandoToken(false);
      _reactNotifications.NotificationManager.error(msg);
    });
  }, [gerandoToken]);

  /**
   * Inicia o processo de assinatura do(s) documento(s) através da API
   * - O processo é iniciado automaticamente após o token de acesso ser gerado
   * - O processo de assinatura é finalizado quando o servidor retorna as assinaturas ou um erro
   * - Se o servidor retornar 401 Unauthorized, o processo é reiniciado, pois o token pode ter expirado,
   * ou já ter sido utilizado (no caso de escopo single_signature)
   *
   */
  (0, _react.useEffect)(function () {
    if (!assinando) {
      return;
    }
    var headers = {
      "Content-type": "application/json",
      Authorization: "Bearer ".concat(_cache.Cache.getAccessToken())
    };
    _axios["default"].post("".concat(apiSttOauth, "/assinatura-digital/signature"), documentos, {
      headers: headers
    }).then(function (response) {
      var data = response.data;
      callback(data);
    })["catch"](function (err) {
      console.log(err);
      var response = err.response;
      if ((response === null || response === void 0 ? void 0 : response.status) === _httpStatusCodes["default"].UNAUTHORIZED || (response === null || response === void 0 ? void 0 : response.status) === _httpStatusCodes["default"].FORBIDDEN) {
        setInit(true);
        return;
      }
      var msg = "Ocorreu um erro desconhecido. Entre em contato com os administradores do sistema.";
      if (response) {
        msg = response.data.msg;
      }
      _reactNotifications.NotificationManager.error(msg);
    })["finally"](function () {
      setAssinando(false);
    });
  }, [assinando]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core2.SttLoading, {
    open: autorizando,
    text: "Autorizando..."
  }), /*#__PURE__*/_react["default"].createElement(_core2.SttLoading, {
    open: gerandoToken,
    text: "Gerando token..."
  }), /*#__PURE__*/_react["default"].createElement(_core2.SttLoading, {
    open: assinando,
    text: "Assinando..."
  }), /*#__PURE__*/_react["default"].createElement(_coreV.SttModal, {
    title: "Assinatura digital",
    open: selecionarEscopo || descobrirUsuario,
    maxWidth: "sm",
    fullWidth: true,
    iconClose: cancelar,
    children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, selecionarEscopo ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_coreV.SttHeading, {
      variant: "h4"
    }, "Escolha o escopo da assinatura"), /*#__PURE__*/_react["default"].createElement(_coreV.SttFormControl, {
      onChange: handleChangeEscopo
    }, /*#__PURE__*/_react["default"].createElement(_coreV.SttRadioGroup, null, documentos.length === 1 && /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.radioLabel
    }, /*#__PURE__*/_react["default"].createElement(_coreV.SttFormControlLabel, {
      control: /*#__PURE__*/_react["default"].createElement(_coreV.SttRadioButton, {
        type: "radio",
        value: _constantes["default"].ESCOPO.SINGLE_SIGNATURE,
        color: "primary",
        checked: escopoCandidato === _constantes["default"].ESCOPO.SINGLE_SIGNATURE
      }),
      label: "Assinatura \xFAnica"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.radioLabel
    }, /*#__PURE__*/_react["default"].createElement(_coreV.SttFormControlLabel, {
      control: /*#__PURE__*/_react["default"].createElement(_coreV.SttRadioButton, {
        type: "radio",
        value: _constantes["default"].ESCOPO.SIGNATURE_SESSION,
        color: "primary",
        checked: escopoCandidato === _constantes["default"].ESCOPO.SIGNATURE_SESSION
      }),
      label: "Sess\xE3o de assinatura"
    }), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      arrow: true,
      title: "Ser\xE1 iniciada uma sess\xE3o de assinatura e os documentos ser\xE3o assinados automaticamente a medida que forem confirmados.",
      placement: "right"
    }, /*#__PURE__*/_react["default"].createElement(_HelpOutline["default"], null))), documentos.length > 1 && /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.radioLabel
    }, /*#__PURE__*/_react["default"].createElement(_coreV.SttFormControlLabel, {
      control: /*#__PURE__*/_react["default"].createElement(_coreV.SttRadioButton, {
        type: "radio",
        value: _constantes["default"].ESCOPO.MULTI_SIGNATURE,
        color: "primary",
        checked: escopoCandidato === _constantes["default"].ESCOPO.MULTI_SIGNATURE
      }),
      label: "Assinatura em lote"
    }), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      arrow: true,
      title: "Os documentos selecionados ser\xE3o assinados de uma s\xF3 vez.",
      placement: "right"
    }, /*#__PURE__*/_react["default"].createElement(_HelpOutline["default"], null)))))) : pscConfig === null || Object.prototype.toString.call(pscConfig) === '[object Object]' ? /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.carregando
    }, /*#__PURE__*/_react["default"].createElement(_coreV.SttCircularProgress, null), /*#__PURE__*/_react["default"].createElement(_coreV.SttText, null, strings.procurandoCertificadosUsuario)) : Array.isArray(pscConfig) ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "cert-list"
    }, pscConfig.map(function (psc) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: psc.psc,
        className: "cert-item"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "cert-logo"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: psc.image_url,
        alt: "".concat(psc.psc, " logo"),
        width: "48",
        height: "48"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "cert-info"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "cert-title"
      }, psc.psc), /*#__PURE__*/_react["default"].createElement("span", {
        className: "cert-desc"
      }, psc.description)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "cert-action"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        onClick: function onClick() {
          setPscConfig(psc);
        },
        className: "cert-link"
      }, "Usar ".concat(psc.psc))));
    })) : /*#__PURE__*/_react["default"].createElement(_coreV.SttText, null, pscConfig)),
    footer: selecionarEscopo && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_coreV.SttButton, {
      variant: "outlined",
      color: "primary",
      onClick: function onClick() {
        return setNaoMostrarNovamente(true);
      }
    }, "N\xE3o mostrar novamente"), /*#__PURE__*/_react["default"].createElement(_coreV.SttButton, {
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        return confirmarEscopo(escopoCandidato);
      },
      disabled: !escopoCandidato
    }, "Confirmar")) || pscConfig !== null && !Array.isArray(pscConfig) && /*#__PURE__*/_react["default"].createElement(_coreV.SttButton, {
      variant: "contained",
      color: "primary",
      onClick: cancelar
    }, "Fechar")
  }));
};
Popup.propTypes = {
  apiSttOauth: _propTypes["default"].string.isRequired,
  cpfResponsavel: _propTypes["default"].string.isRequired,
  documentos: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    // IDs de laudo legados são numéricos; sessões novas usam operationId opaco.
    id: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
    alias: _propTypes["default"].string
  })).isRequired,
  callback: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func
};
var _default = Popup;
exports["default"] = _default;